import React, { lazy, Suspense } from 'react';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import retry from '@wix/da-shared-react/pkg/utils/webpack/chunkRetry';
import useAdoptsI18next from '../hooks/useAdoptsI18next';
const LoadableModal = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "exclusive_resale_countdown" */ './ResaleCountdownModal')));
const I18NextLoader = ()=>{
    useAdoptsI18next();
    return null;
};
const ResaleCountdownModalLoadable = (props)=>/*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "SellerModalLoadable"
    }, /*#__PURE__*/ React.createElement(Suspense, {
        fallback: /*#__PURE__*/ React.createElement(LoadingIndicator, {
            view: 'llama',
            withOverlay: true,
            usePortal: true
        })
    }, /*#__PURE__*/ React.createElement(I18NextLoader, null), /*#__PURE__*/ React.createElement(LoadableModal, props)));
ResaleCountdownModalLoadable.displayName = 'ResaleCountdownModalLoadable';
export default ResaleCountdownModalLoadable;
